module.exports = {
  src: __webpack_public_path__ + "logo-google-play-fr-10c221df409050c19c77ad18e6882ce3.svg",
  width: 12931,
  height: 3831,
  bytes: 10042,
  type: "svg",
};
module.exports.toString = function() {
  return __webpack_public_path__ + "logo-google-play-fr-10c221df409050c19c77ad18e6882ce3.svg";
};